import React from 'react'
import Icon from './Icon'

class Interview extends React.Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg width='14px' height='19px' viewBox='0 0 14 19'>
          <g
            id='Page-1'
            stroke='none'
            strokeWidth='1'
            fill='none'
            fillRule='evenodd'
          >
            <g
              id='expertlist'
              transform='translate(-27.000000, -646.000000)'
              fill='#7E8DA2'
            >
              <g id='ic_mic' transform='translate(22.000000, 644.000000)'>
                <path
                  d='M12,14 C13.66,14 14.99,12.66 14.99,11 L15,5 C15,3.34 13.66,2 12,2 C10.34,2 9,3.34 9,5 L9,11 C9,12.66 10.34,14 12,14 L12,14 Z M17.3,11 C17.3,14 14.76,16.1 12,16.1 C9.24,16.1 6.7,14 6.7,11 L5,11 C5,14.41 7.72,17.23 11,17.72 L11,21 L13,21 L13,17.72 C16.28,17.24 19,14.42 19,11 L17.3,11 L17.3,11 Z'
                  id='Icon'
                />
              </g>
            </g>
          </g>
        </svg>
      </Icon>
    )
  }
}

export default Interview
